import { Box, Container, Flex } from "@chakra-ui/layout";
import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import FormLoadingOverlay from "../components/common-quote/FormLoadingOverlay";

const OKTA_TOKEN_STORAGE_KEY = "okta-token-storage";
const OKTA_CACHE_STORAGE_KEY = "okta-cache-storage";

/**
 * The reason this view exists is to provide a SSO experience
 * for users entering the app from the Okta dashboard.
 * We don't want them to have to login twice so we set up /login/sso route
 * which corresponds to this view.
 *
 * See GH issue for solution: https://github.com/okta/okta-react/issues/84
 * See Here for implementation: https://github.com/okta/okta-auth-js#signinwithredirectoptions
 */
function LoginSSOView() {
  const { oktaAuth } = useOktaAuth();
  const history = useHistory();

  const loginWithSingleSignOn = React.useCallback(async () => {
    if (oktaAuth.isLoginRedirect()) {
      await oktaAuth.handleLoginRedirect();
    } else if (!(await oktaAuth.isAuthenticated())) {
      // Start the browser based oidc flow, then parse tokens from the redirect callback url
      oktaAuth.signInWithRedirect();
    } else {
      history.push("/");
    }
  }, [oktaAuth, history]);

  useEffect(() => {
    localStorage.removeItem(OKTA_TOKEN_STORAGE_KEY);
    localStorage.removeItem(OKTA_CACHE_STORAGE_KEY);
    loginWithSingleSignOn().then((x) => x);
  }, [loginWithSingleSignOn]);

  return (
    <Container position="relative" maxW="1440px" height="100vh">
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="full"
      >
        <Box
          position="relative"
          minHeight={500}
          padding={8}
          boxShadow="md"
          backgroundColor="white"
          maxWidth={500}
          w="full"
        >
          <FormLoadingOverlay label="Signing you in..." />
        </Box>
      </Flex>
    </Container>
  );
}

export default LoginSSOView;
